import { call, put, takeEvery } from 'redux-saga/effects'
import { types } from '../../types'
import { getInstruction, setUserOffline, setUserOnline } from '../apiRequests/secretaryRequest'

function* handleInstructionData(action) {
    try {
        const response = yield call(getInstruction, action.params)
        yield put({
            type: types.GET_INSTRUCTION_SUCCESS,
            action: response,
        })
    } catch (error) {
        yield put({
            type: types.GET_INSTRUCTION_ERROR,
            error: error.response,
        })
    }
}

function* handleSetUserOnline() {
    try {

        const response = yield call(setUserOnline)
        yield put({
            type: types.SET_USER_ONLINE_SUCCESS,
            action: response,
        })
    } catch (error) {
        yield put({
            type: types.SET_USER_ONLINE_ERROR,
            error: error.response,
        })
    }
}

function* handleSetUserOffline() {
    try {
        const response = yield call(setUserOffline)
        yield put({
            type: types.SET_USER_OFFLINE_SUCCESS,
            action: response,
        })
    } catch (error) {
        yield put({
            type: types.SET_USER_OFFLINE_ERROR,
            error: error.response,
        })
    }
}






function* watcherSecretarySaga() {
    // yield takeEvery(types.GET_INSTRUCTION_REQUEST, handleInstructionData)
    yield takeEvery(types.SET_USER_ONLINE_REQUEST, handleSetUserOnline)
    yield takeEvery(types.SET_USER_OFFLINE_REQUEST, handleSetUserOffline)


}

export default watcherSecretarySaga